import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Insights() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Insights from Client</h2>
            <p>
              The client wanted all their outlets and eCommerce presence to be
              more connected and synchronized. To deliver an exceptional
              experience to customers, the idea was to enable customers to
              browse digitally or visit one of the outlets, either way, the same
              products, and choices.
            </p>
            <p>
              An omnichannel approach was needed to scale properly and based on
              our communication, we gathered the vision our client had in the
              long run and aligned it with existing market trajectories.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/alhussaini/tek-img_04.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={717}
              height={716}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Insights;
